import React from 'react';
import {Content, Container, EventInformation, DataContainer} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Button, Line, Typography} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {StreamIcon} from 'app/styles/stream';
import PropTypes from 'prop-types';
import {CustomLinkContainer} from 'app/components/match/matchLive/tickerStreamElementStyles';
import {HowToReg} from '@mui/icons-material';
import {useParams} from 'react-router';

const MatchEventLineup = ({team}) => {
  const {matchSlug} = useParams();
  return (
    <LinkOnComponent to={`/match/${matchSlug}/lineup`}>
      <Content>
        <Container>
          <EventInformation>
            <StreamIcon color={COLORS.darkGreen}>
              <HowToReg style={{color: COLORS.white, fontSize: 20}} />
            </StreamIcon>
          </EventInformation>
          <DataContainer>
            <Typography variant='body2'>{`Die Aufstellung für ${team.name.full} ist eingetragen! 💪`}</Typography>
            <CustomLinkContainer>
              <Button label='Aufstellung checken' text />
            </CustomLinkContainer>
          </DataContainer>
        </Container>
        <Line />
      </Content>
    </LinkOnComponent>
  );
};

MatchEventLineup.propTypes = {
  team: PropTypes.object.isRequired,
};

export {MatchEventLineup};
